module.exports = __webpack_public_path__ + "img/foto_fake1.f45ea885.jpg";